import { Subscribable } from '@benzinga/subscribable';
import { HoldingsRestful } from './restful';
import { HoldingsRequestEvent } from './manager';
import { Session } from '@benzinga/session';
import { ingestHoldings } from './ingress';

export class HoldingsRequest extends Subscribable<HoldingsRequestEvent> {
  private restful: HoldingsRestful;

  constructor(session: Session) {
    super();
    this.restful = new HoldingsRestful(session);
  }
  getHoldings = async () => {
    const holdings = await ingestHoldings(this.restful.getHoldings());
    if (holdings.err) {
      this.dispatch({
        error: holdings.err,
        type: 'holdings:error_holdings',
      });
      return { err: holdings.err };
    }
    return { ok: holdings.ok };
  };
}
